<template>
  <div class="text-start">
    <form @submit.prevent="onSubmitLocation" :method="method" :class="form_class" ref="location_form" id="location_form" novalidate>

      <div class="row mb-3 justify-content-left">
        <div class="col-12">
          <button class="btn btn-primary btn-lg btn-block float-end" type="submit" id="submit">{{ $t("submit" )}}</button>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <label for="name" class="float-left">{{ $t("attributes.location.name") }}</label>
          <div class="input-group">
            <input type="text" :value="location.name" class="form-control" name="name" ref="name" @input="onUpdateFormParam" required>
            <div class="invalid-feedback text-left">{{errorMessagesFor('name')}}</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <label for="description" class="float-left">{{ $t("attributes.location.description") }}</label>
          <div class="input-group">
            <textarea :value="location.description" class="form-control" name="description" ref="description" @input="onUpdateFormParam"/>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-6">
          <label for="area" class="float-left">{{ $t("attributes.location.area") }}</label>
          <div class="input-group">
            <input type="number" :value="location.area" class="form-control" name="area" ref="area" @input="onUpdateFormParam" step="any" min="0"/>
          </div>
        </div>
        <div class="col-6">
          <label for="area_unit" class="float-left">{{ $t("attributes.location.area_unit") }}</label>
          <div class="input-group">
            <select :value="location.area_unit" class="form-control" name="area_unit" ref="area_unit" @input="onUpdateFormParam">
              <option></option>
              <option v-for="unit in areaUnits" :key="unit.code" :value="unit.code">
                {{ unit.code }}
              </option>
            </select>
          </div>
        </div>        
      </div>      

      <div class="row mb-3 justify-content-left">
        <div class="col-12">
          <button class="btn btn-primary btn-lg btn-block float-end" type="submit" id="submit">{{ $t("submit" )}}</button>
        </div>
      </div>

    </form>  
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { setFieldValidity } from '@/common/form_field_validation';

export default {
  name: 'LocationForm',
  props: [
    "locationUuid",
    "locationType",
    "siteUuid"
  ],
  emits: [
    "location-updated",
    "location-created"
  ],
  setup(props) {
    const store = useStore();

    let editingLocation
    let method
    let site_uuid
    const location_type = ref(props.locationType)

    if (props.locationUuid) {
      const store = useStore();
      editingLocation = store.getters.getLocationByUUID(props.locationUuid);
      site_uuid = editingLocation.site_uuid; 
      method = "PUT"
    } else {
      site_uuid = ref(props.siteUuid);
      editingLocation = {
        uuid: null,
        site_uuid: site_uuid.value,
        location_type: location_type.value,
        name: null,
        description: null,
      }
      method = "POST"
    }

    const areaUnits = store.getters.getUnitsByType("Unit::AreaUnit");
    console.log("Inside locations/Form.vue, setup() areaUnits ==> ", areaUnits);

    return {
      location: editingLocation,
      site_uuid,
      location_type,
      areaUnits,
      method
    }    
  },
  data() {
    return {
      form_class: 'needs-validation',
      form_errors: {},
      locationUUID: null
    }
  },
  methods: {
    onUpdateFormParam(e) {
      const fieldName = e.target.name;
      this.location[fieldName] = e.target.value;
      setFieldValidity(this.$refs, fieldName, null);
    },
    validateForm() {
      const thisForm = this.$refs.location_form;
      const existingLocation = this.$store.getters.getLocationByName(this.$refs.name.value);
      console.log("Inside locations/From.vue validateForm, existingLocation ==> ", existingLocation);

      // use the browser's checkValidity function to validate the form.
      if (!thisForm.checkValidity()) {
      // then we gather the native error messages
        const inputFields = Array.from(thisForm.getElementsByTagName("input")).concat(Array.from(thisForm.getElementsByTagName("select")));
        const thisHandle = this;
        inputFields.forEach(function(input) {
          const paramName = input.name
          console.log(`Inside validateForm, input.validationMessage of ${paramName} ===> `, input.validationMessage);
          if (input.validationMessage.length > 0) {
            const paramName = input.name;
            thisHandle.form_errors[paramName] = input.validationMessage;
          }
        });
      }

      // if this.form_errors are empty then the form is valid
      return this.isFormErrorFree(this.form_errors);
    },
    isFormErrorFree(form_errors) {
      return Object.values(form_errors).reduce(function(acc, val1) { 
        return ((val1 === null) || (val1.length === 0)) && acc 
      }, true);
    },    
    async onSubmitLocation() {
      if (this.validateForm()) {
        if (this.location.uuid) {
          await this.$store.dispatch("modifyLocation", this.location);
          this.$emit("location-updated", { locationUUID: this.location.uuid });
        } else {
          const newLocationUUID = await this.$store.dispatch("addLocation", this.location);
          this.$emit("location-created", { locationUUID: newLocationUUID });
        }        
      } else {
        console.log("Inside locations/From.vue onSubmitLocation, validateFrom not ok");
        this.form_class = 'was-validated';
        this.$forceUpdate(); // need this or error message may not appear
        return;
      }        
    },
    errorMessagesFor(fieldName) {
      if (this.$refs[fieldName]) {
        return this.$refs[fieldName].validationMessage
      }
    }
  }
}
</script>